export default __webpack_public_path__ + "static/media/Erasmus 2019_prezentacjaPL.abfcd10a.pdf";